import app from 'app';

export default {
  $bus: new app.Vue({ functional: true }),

  getId(audio) {
    return (audio && audio.metadata && audio.metadata.assetUUID) || null;
  },

  /**
   * Get file list from DnD or change:file event
   * @param e {Event}
   * @return {*|ColdPromise}
   * @resolved {Array}
   */
  getFileList(e) {
    const rv = new _.ColdPromise();

    try {
      const chosenFiles = app.getFilesFromEvent(e);
      const supportedFiles = [];
      let showDialog = true;

      for (let n = 0, N = chosenFiles.length; n < N; n++) {
        const file = chosenFiles[n];

        // enrich each object with custom properties
        file._fileName = file.name.replace(/\.[^/.]+$/, '');
        file._fileExt = file.name
          .replace(file._fileName, '')
          .replace(/^\./, '')
          .toUpperCase();

        // filter-out unsupported files
        if (app.DEFAULT.EXCLUSIVE_AUDIO_MIMES.indexOf(file.type) < 0) {
          if (showDialog) {
            // show error dialog only once
            showDialog = false;
            app.dialog.error({
              type: app.dialog.types.ERROR_1,
              title: 'Invalid File Type',
              showContactCsm: false,
              description:
                'Compatible file types are: ' +
                app.DEFAULT.SUPPORTED_AUDIO_EXTENSIONS,
            });
          }

          continue;
        }

        supportedFiles.push(file);
      }

      rv.resolve(supportedFiles);
    } catch (bug) {
      rv.reject(bug);
    }

    return rv;
  },

  getUploadQueueModel(file, programmerId) {
    const now = Date.now();
    return new app.namespace.Model.UploadQueueModel(
      {
        // Its needed for client uploading infrastructure
        blob: file,
        progress: {
          /* will be updated during upload*/
        },

        // required for initial preupload request (UploadQueueModel::_createAsset)
        fileName: file.name,
        mimeType: file.type, // v2

        // I think its needed for server uploading infrastructure
        creationDate: now,
        privacy: app.privacyType.ORGANIZATION_PRIVATE,
        programmersIds: [programmerId],
        mediaAssetSubType: app.mediaAssetSubType.BG_MUSIC,
        type: app.assetType.AUDIO,

        // I think its actual asset metadata to be stored
        favorite: false,
        metadata: {
          assetSubType: app.mediaAssetSubType.BG_MUSIC,
          // temporary id
          assetUUID: app.guid(),
          title: file._fileName,
          creationDate: now,
          uploadStatus: app.uploadStatus.UPLOAD,
        },
      },
      {
        uploadType: app.uploadType.AUDIO_ASSET,
      }
    );
  },

  /**
   * tracking history over foreign uploads (uploaded by another user and visible to you as being "processing")
   * in attempt to auto-update UI when its done
   */
  foreignUpload: {
    history: new Map(),

    track(foreignAudio) {
      const id = foreignAudio.metadata.assetUUID;
      console.info('api.foreignUpload::track', id);

      if (this.history.has(id)) {
        // id already exist - update reference to audio and exit
        this.history.set(id, foreignAudio);
        return;
      } else {
        this.history.set(id, foreignAudio);
      }

      app.api.realTime
        .listenOnAsset(id)
        .then(
          () => {
            const cp = app.api.asset.fetch(id);
            cp.then(
              (res) => {
                if (this.history.has(id)) {
                  const audio = this.history.get(id);
                  // clear existing props (without changing containing object)
                  _.each(Object.keys(audio), (key) => {
                    if (key !== 'metadata') {
                      delete audio[key];
                    }
                  });
                  // update props
                  Object.assign(audio, res);
                  // obviously: audio.metadata.uploadStatus === app.uploadStatus.DONE;
                }
              },
              () => {
                const audio = this.history.get(id);
                audio.metadata.uploadStatus = app.uploadStatus.FAILED;
              }
            );
            cp.finally(() => {
              this.history.delete(id);
            });
          },
          () => {
            if (this.history.has(id)) {
              const audio = this.history.get(id);
              audio.metadata.uploadStatus = app.uploadStatus.FAILED;
              this.history.delete(id);
            }
          }
        )
        .finally(() => {
          if (this.history.has(id)) {
            app.api.realTime.cancelListenOnAsset(id);
          }
        });
    },

    clear() {
      this.history.forEach((audio, id) => {
        app.api.realTime.cancelListenOnAsset(id);
      });
      this.history.clear();
    },
  },

  /**
   * @param e1 {Event}
   * @param e2 {Event}
   * @return {number}
   */
  distance(e1, e2) {
    return Math.sqrt(
      Math.pow(e1.pageX - e2.pageX, 2) + Math.pow(e1.pageY - e2.pageY, 2)
    );
  },

  getGenres(programmerId) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: app.apiUrl('/api/v1/assets/audio/bgMusic/filters'),
        type: 'GET',
        data: { programmerId },
        dataType: 'json',
      })
        .done((res) => {
          if (
            _.isPlainObject(res) &&
            _.isArray(res.genres) &&
            _.isArray(res.moods)
          ) {
            resolve(res);
          } else {
            reject({ error: 'bad response format' });
          }
        })
        .fail((res) => {
          reject(res);
        });
    });
  },
};
